// **************
// p-cardagendamentoopcoes.jsx
// autor: Walcledson de Paula
// data: 15/11/24 / 16:32h
// data: 19/11/24 / 15:06h | acrescentado mensagem zapzap confirmação (reenvio)
// data: 01/12/24 / 21:23h | limpamos os comentários desnecessários
// *************

import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import apiaxios from '../../../../Services/apiaxios.js';
import handleApiError from '../../../../Services/apiErrorHandler.js';
import { decrypt } from '../../../../Services/cryptoUtils'
import { AutoLogout } from '../../../../Services/autologout.js';
import jsPDF from "jspdf"; // gerar o recibo em PDF

import './p_cardagendamentoopcoes.css';

const CardAgendamentoOpcoes = ({ id_usuario, tipoAtendimento, agendamento, closeDock, paginaAgendamento }) => {
    // verifica se os tokens estão corretos 
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
       
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    const [loading, setLoading] = useState(false);
    const MySwal = withReactContent(Swal);
    const [todosStatus, setTodosStatus] = useState([]);
    const [nenhumStatusEncontrado, setNenhumStatusEncontrado] = useState(false);
    const pdf = new jsPDF(); // gerar os dados do PDF

    // Função para formatar o valor em moeda
    const formatCurrency = (value) => {
        return value !== undefined && value !== null ? 
            value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 
            'N/A';
    };

    // excluir agendamento via botão "opções"
    const handleExcluir = (agendamento) => {
            closeDock();
            // console.log ('dentro do handleexcluir no início array "agendamento:" ', agendamento, agendamento.agendamento_id);
            const ID_RESERVA = agendamento.agendamento_id;
            const DATA_RESERVA_STRING = agendamento.agendamento_data;
    
            const [datePart, timePart] = DATA_RESERVA_STRING.split(' ');
            const [day, month, year] = datePart.split('/');
            const [hours, minutes, seconds] = timePart.split(':');
            const DATA_RESERVA = new Date(year, month - 1, day, hours, minutes, seconds);
    
            const dataAtual = new Date();
    
            if (!dataAtual) {
                console.error('Erro: dataAtual está indefinido');
                return;
            }
    
            if (DATA_RESERVA < dataAtual) {
                Swal.fire('Atenção', 
                            'Prazo para exclusão vencido. Agendamento em análise!', 
                            'warning');
                    return;
            } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
                dataAtual.getHours() >= DATA_RESERVA.getHours() - 2) {
                Swal.fire('Atenção', 
                            'Prazo para exclusão vencido. Não falte ao compromisso com o prestador de serviços!',
                            'warning');
                    return;
            } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
                dataAtual.getHours() >= DATA_RESERVA.getHours() && 
                dataAtual.getHours() < DATA_RESERVA.getHours() + 3) {
                Swal.fire('Atenção', 
                            'Prazo para exclusão vencido. Você já deve estar dentro do atendimento!', 
                            'warning');
                    return;
            }
    
            Swal.fire({
                title: 'Excluir Agendamento',
                html: `
                    <label for="motivo">Motivo do Cancelamento:</label>
                    <textarea id="motivo" class="swal2-textarea" placeholder="Digite o motivo" minlength="10"></textarea>
                    <p>ID_RESERVA: ${ID_RESERVA}</p>
                    <p>Data/Hora exclusão: ${dataAtual.toLocaleString()}</p>
                `,
                showCancelButton: true,
                confirmButtonText: 'Excluir',
                cancelButtonText: 'Cancelar',
                preConfirm: () => {
                    const motivo = Swal.getPopup().querySelector('#motivo').value;
                    if (!motivo || motivo.length < 10) {
                        Swal.showValidationMessage('Para cancelar seu agendamento, você precisa primeiro dizer o motivo (mínimo 10 caracteres)');
                        return false;
                    }
                    return motivo;
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const motivo = result.value;
                    // const id_usuario = JSON.parse(localStorage.getItem("tokenapw")).id_usuario;
                    setLoading(true)
                    if (tipoAtendimento === 0) {
                        apiaxios.put('reserva/excluirWeb', {
                            id_reserva: ID_RESERVA,
                            tipo_exclusao: 'P',
                            id_usuario,
                            obs_cancel: motivo
                        }, {params: {id_usuario, token: tokenASW}})
                        .then(response => {
                            if (response.status === 200 && response.data.retorno === "OK") {
                                Swal.fire('Excluído!', 'Seu agendamento foi excluído com sucesso.', 'success');
                                // setAgendamentos(agendamentos.filter(a => a.agendamento_id !== agendamento.agendamento_id));
                                // // atualizarAgendamentosColaborador(selectedColaborador, pagina);
                            } else {
                                Swal.fire('Erro', response.data.retorno || 'Erro ao excluir agendamento', 'error');
                            }
                        })
                        .catch(error => {
                            Swal.fire('Erro', 'Erro ao excluir agendamento: ' + error, 'error');
                        }).finally (
                            setLoading(false)
                        );
                    } else { // tipoAtendimento===1
                        apiaxios.put('reserva/excluirColaboradorWeb', {
                            id_reserva: ID_RESERVA,
                            tipo_exclusao: 'P',
                            id_usuario,
                            obs_cancel: motivo
                        }, {params: {id_usuario, token: tokenASW}})
                        .then(response => {
                            if (response.status === 200 && response.data.retorno === "OK") {
                                Swal.fire('Exclusão!', 'Agendamento foi excluído com sucesso.', 'success');
                                // const novosAgendamentos = agendamentos.filter(a => a.ID_RESERVA !== ID_RESERVA);
    
                                // // Log para verificar o array atualizado
    
                                // // Atualiza o estado de agendamentos com o novo array filtrado
                                // setAgendamentos(novosAgendamentos);
                            } else {
                                Swal.fire('Erro', response.data.retorno || 'Erro ao excluir agendamento', 'error');
                            }
                        })
                        .catch(error => {
                            Swal.fire('Erro', 'Erro ao excluir agendamento: ' + error, 'error');
                        }).finally (
                            setLoading(false)
                        );
                    }
                }
            });
    };

    // novo agendamento para o mesmo cliente via botão "opções"
    const handleNovoAgendamento = async (agendamento) => {
        closeDock();
        alert('novo agendamento');
    };

    // enviar confirmação via zapzap via botão "opções"
    const handleAlterarAgendamento = async (agendamento) => {
        closeDock();
        alert('alterar agendamento');
    };

    // gerar recibo PDF via botão "opções"
    const handleGerarRecibo = async (agendamento) => {
        if (!agendamento || !agendamento.agendamento_id) {
            console.error("Agendamento inválido:", agendamento);
            return;
        }

        // console.log ('agendamento clicado ', agendamento.agendamento_id);
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a5", // Tamanho menor
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const margin = 10;
        const rightMargin = pageWidth - margin;
        let yPosition = margin;
    
        // Título do recibo (centralizado)
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(22);
        pdf.text("Recibo de Serviço", pageWidth / 2, yPosition, { align: "center" });
        yPosition += 15;
    
        // Dados do recibo
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(16);
        pdf.text(`Recibo: ${agendamento.agendamento_id}`, margin, yPosition);
        yPosition += 10;
    
        // Dados do cliente
        pdf.setFontSize(16);
        pdf.text("Dados do cliente:", margin, yPosition);
        yPosition += 10;
    
        pdf.setFontSize(14);
        pdf.text(`Nome: ${agendamento.agendamento_nome}`, margin, yPosition);
        yPosition += 8;
        pdf.text(`Telefone: ${agendamento.agendamento_fone}`, margin, yPosition);
        yPosition += 15;
    
        // Linha separadora
        pdf.setDrawColor(0, 0, 0); // Cor preta
        pdf.setLineWidth(0.3); // Espessura da linha
        pdf.line(margin, yPosition - 5, rightMargin, yPosition - 5); // Linha horizontal
    
        // Itens do serviço
        pdf.setFontSize(16);
        pdf.text("Itens:", margin, yPosition);
        yPosition += 10;
    
        pdf.setFontSize(16);
        pdf.text("Serviço:", margin, yPosition);
        pdf.text(`${agendamento.agendamento_descricao}`, rightMargin, yPosition, { align: "right" });
        yPosition += 8;
    
        pdf.text("Valor:", margin, yPosition);
        pdf.text(`R$ ${agendamento.agendamento_vr.toFixed(2)}`, rightMargin, yPosition, { align: "right" });
        yPosition += 8;
    
        pdf.text("Desconto:", margin, yPosition);
        pdf.text(`R$ ${agendamento.agendamento_desc.toFixed(2)}`, rightMargin, yPosition, { align: "right" });
        yPosition += 8;
    
        pdf.text("Valor Total:", margin, yPosition);
        pdf.text(`R$ ${agendamento.agendamento_vrtot.toFixed(2)}`, rightMargin, yPosition, { align: "right" });
        yPosition += 15;
    
        // Linha separadora
        pdf.line(margin, yPosition - 5, rightMargin, yPosition - 5);
    
        // Data e hora do agendamento
        pdf.setFontSize(16);
        pdf.text(`Data: ${agendamento.agendamento_data}`, margin, yPosition);
        pdf.text(`Hora: ${agendamento.agendamento_hora} h`, rightMargin, yPosition, { align: "right" });
        yPosition += 15;
    
        // Linha separadora
        pdf.line(margin, yPosition - 5, rightMargin, yPosition - 5);
    
        // Data e hora de geração do recibo
        const now = new Date();
        const formattedDate = new Intl.DateTimeFormat("pt-BR", {
            dateStyle: "short",
            timeStyle: "short",
        }).format(now);
    
        pdf.text(`Gerado em: ${formattedDate}`, margin, yPosition);
    
        // Baixar o PDF
        pdf.save(`Recibo:${agendamento.agendamento_nome}-${agendamento.agendamento_id}.pdf`);
    };
    
    // enviar confirmação via zapzap via botão "opções"
    const handleEnviarConfirmacao = async (agendamento) => {
        closeDock();
        if (agendamento.agendamento_fone ) {
            handleEnviarAgendamentoViaWhats(agendamento.agendamento_fone);
        }
    };

    const handleEnviarAgendamentoViaWhats = (agendamento_fone) => {
        const whatsappNumber = `55${agendamento_fone.replace(/\D/g, '')}`;
        window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessageEnviarAgendamento}`, '_blank');
    };

    // Construir a mensagem personalizada para WhatsApp
    const whatsappMessageEnviarAgendamento = encodeURIComponent(
        `****************************
            LEMBRETE DE AGENDAMENTO:
            CLIENTE: ${agendamento.agendamento_nome || "Nome cliente não informado"}
            TELEFONE: ${agendamento.agendamento_fone || "Telefone do cliente não informado"}
            ****************************
            VALOR: ${formatCurrency(agendamento.agendamento_vrtot) || "Valor não informado"}
            DATA: ${agendamento.agendamento_data || "Data não informada"}
            HORÁRIO: ${agendamento.agendamento_hora || "Horário não informado"}
            ****************************
            LEMBRETE DE AGENDAMENTO
        ****************************`
    );    

    // mudar status via botão "opções"
    const handleMudarStatus = async (agendamento) => {
        closeDock();
        const { ID_RESERVA } = agendamento;
    
        // console.log("array todosStatus ", todosStatus);
        try {
            let selectedStatus = 1;
    
            MySwal.fire({
                title: 'Selecione o novo Status:',
                html: `
                    <div id="statusSelect">
                        <select id="statusDropdown" class="swal2-select">
                            ${todosStatus
                                .filter(status => ![3, 4, 6, 8, 9].includes(status.STA_ID)) // Filtra os status indesejados
                                .map(status => `
                                    <option value="${status.STA_ID}" ${status.STA_ID === 1 ? 'selected' : ''}>
                                        ${status.STA_DESCRICAO}
                                    </option>`)
                                .join('')}
                        </select>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: 'Alterar Status',
                cancelButtonText: 'Voltar',
                preConfirm: () => {
                    const selectedValue = document.getElementById('statusDropdown').value;
                    if (!selectedValue) {
                        Swal.showValidationMessage('Por favor, selecione um status.');
                        return false;
                    }
                    return selectedValue;
                }
            }).then(async (result) => {
                if (result.isConfirmed) {
                    selectedStatus = result.value;
    
                    // Faça a requisição para atualizar o status
                    const response = await apiaxios.put(`/reserva/StatusWeb`, {
                        id_status: selectedStatus,
                        id_reserva: agendamento.agendamento_id,
                        tipoAtendimento,
                        cod_notificacao: 24
                    },
                    {
                        params: {
                            id_usuario,
                            token: tokenASW
                        }
                    });

                    if (response.status === 200 && response.data.retorno === "OK") {
                        Swal.fire('Sucesso', 'Status alterado com sucesso!', 'success');
                        // Atualize a UI se necessário
                    } else {
                        Swal.fire('Erro', response.data.retorno || 'Erro ao mudar o Status', 'error');
                    }
                }
            });
        } catch (error) {
            Swal.fire('Erro', 'Erro ao mudar o status: ' + error, 'error');
        }
    };

    useEffect(() => {
        const loadStatus = async () => {
            try {
                const retornoTodosStatus = await fetchStatus();
                setTodosStatus(retornoTodosStatus);
            } catch (error) {
                console.error('Erro ao buscar os status: ', error);
            }
        };
        loadStatus();
    },[]);

    const fetchStatus = async () => {
        try {
            setLoading(true);
            const statusResponse = await apiaxios.get(`reserva/StatusListarWeb?id_usuario=${id_usuario}&token=${tokenASW}`);

            if (statusResponse.status === 200 && statusResponse.data.length > 0) {
                return statusResponse.data;
            } else {
                setNenhumStatusEncontrado(true);
                return [];
            }
        } catch (error) {
            console.error('erro: ', error);
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };    



    return (
        <div className='container-fluid h-100 pt-4 sidebar p-4'>
            <h4 className='d-inline'>
                <div className='mb-4'>
                    {/* {console.log('agendamento.agendamento_id ', agendamento.agendamento_id)} */}
                    Agendamento #id : {agendamento.agendamento_id}
                </div>
            </h4>
                <div className='row tela-card'>
                    <button disabled className="btn btn-info mb-4" 
                        onClick={() => handleNovoAgendamento(agendamento)}
                        >
                        <i className="bi bi-file-earmark-plus"></i> Novo agendamento
                    </button>
                    {(paginaAgendamento === "p_abertos" ) && (
                        <button disabled className="btn btn-info mb-4" 
                            onClick={() => handleAlterarAgendamento(agendamento)}
                            >
                            <i className="bi bi-pencil-square"></i> Alterar agendamento
                        </button>
                    )}
                    {(paginaAgendamento === "p_abertos" ) && (
                        <button className="btn btn-success mb-4" 
                            onClick={() => handleEnviarConfirmacao(agendamento)}
                            >
                            <i className="bi bi-whatsapp"></i> Reenviar Confirmação
                        </button>
                    )}
                    <button className="btn btn-info mb-4" 
                        onClick={() => handleGerarRecibo(agendamento)}
                        >
                        <i className="bi bi-receipt-cutoff"></i> Gerar recibo
                    </button>
                    {(paginaAgendamento === "p_abertos" ) && (
                        <button className="btn btn-info mb-4" 
                            onClick={() => handleMudarStatus(agendamento)}
                            >
                            <i className="bi bi-calendar2-check"></i> Alterar o Status
                        </button>
                    )}
                    {(paginaAgendamento === "p_abertos" ) && (
                        <button className="btn btn-danger mt-4" 
                            onClick={() => handleExcluir(agendamento)}
                            >
                            <i className="bi bi-x-circle-fill"></i> Excluir agendamento
                        </button>
                    )}
                </div>            
        </div>
    );
};

export default CardAgendamentoOpcoes;